import _ from 'lodash'
import module from './module'
import api from '../services/api'
import odataMixin from '@/core/store/mixin/odata'
import crudMixin from '@/core/store/mixin/crud'

const res = _.merge({},
  odataMixin(api),
  crudMixin(api),
  module,
)

export default res
